window.cb_switch_employees = function cb_switch_employees(result) {
  // Display pin screen if valid HTML is return and verify_pin isn't already visible
  if (result.html && $('#verify_pin').length === 0) {
    window.merchantos.display.lockScreen();
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    window.merchantos.display.addContent(null, result.html, { skip_wrapper: true });
    $("#verify_pin [name='access_pin']").trigger('select');
  }
};

window.verifyWithPIN = function verifyWithPIN() {
  window.no_page_timeouts = true;
  const content_map = {} as ContentMap;
  content_map.form_name = 'switch_employees';
  content_map.values = {
    origin: `${window.location.pathname}${window.location.search}`,
  };

  window.doServerCall(content_map, window.cb_switch_employees);
};

window.cb_verifypin = function cb_verifypin(result) {
  if (!result.pin_verified) {
    $('input:visible[autofocus="autofocus"]').trigger('focus');
    return;
  }

  const formNamesDenylist = ['close_register'];
  const isDenyListed = _.some(formNamesDenylist, formName =>
    window.location.href.includes(formName)
  );

  // Only show the CFD sale on pin unlock if the page is the register
  if (window.location.pathname === '/register.php' && !isDenyListed && window.socketClient) {
    const client = window.socketClient;
    const CFD_MESSAGES = window.socketClient.CFD_MESSAGES;
    client.send(CFD_MESSAGES.SHOW_SALE);
  }

  // The session data is cached so make sure we grab the latest
  window.merchantos.session.clearCache();
  window.merchantos.session
    .init()
    .done(() => {
      if (window.Analytics) {
        window.Analytics.submitLastSeenEvent();
      }
    })
    .always(() => {
      let url;
      if (result.new_transaction_id) {
        let form_name: string;
        if (result.customer_id) {
          form_name = `select_customer&customer_id=${result.customer_id}`;
          if (result.view) {
            form_name += `&view=${result.view}`;
          }
        } else if (result.view) {
          form_name = `change_view&view=${result.view}`;
        } else if (result.edit_workorder_after_pin) {
          form_name = 'edit_workorder_mode';
          if (result.workorder_id) {
            form_name += `&workorder_id=${result.workorder_id}`;
          }
        } else if (result.complete_workorder_after_pin) {
          form_name = 'complete_workorder';
        } else if (result.load_refund_after_pin) {
          form_name = 'load_refund';
          if (result.transaction_id) {
            form_name += `&transaction_id=${result.transaction_id}`;
          }
        } else if (result.reopen_transaction_after_pin) {
          form_name = 'reopen_transaction';
          if (result.transaction_id) {
            form_name += `&transaction_id=${result.transaction_id}`;
          }
        }

        url = '/register.php';
        // @ts-expect-error ts-migrate(2454) FIXME: Variable 'form_name' is used before being assigned... Remove this comment to see the full error message
        if (form_name) {
          url += `?form_name=${form_name}`;
        }
        window.merchantos.utils.openUrl(url);
        return;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'new_workorder' does not exist on type 'P... Remove this comment to see the full error message
      if (result.new_workorder) {
        url = '?name=workbench.views.beta_workorder&form_name=view&id=&tab=details';
        window.merchantos.utils.openUrl(url);
        return;
      }

      if (result.fnc && result.url) {
        window.merchantos.utils.openUrl(result.url);
        return;
      }

      if (result.employee_switched) {
        window.merchantos.utils.openUrl('/register.php');
        return;
      }

      if ($('#verify_pin').attr('reload_after_pin')) {
        window.location.reload();
        return;
      }

      $('#verify_pin').remove();

      $('.modal-wrapper').hide();
      window.merchantos.display.unlockScreen();

      window.no_page_timeouts = false;
      window.resetIdleTimer();
    });
};

$(document).on('submit', '#verify_pin form', () => {
  const content_map = {} as ContentMap;
  const form = $('#verify_access_pin_form');

  $.each(
    form.serializeArray(),
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // eslint-disable-next-line no-return-assign
    (_, field) => (content_map[field.name] = field.value)
  );

  if (!content_map.form_name) {
    $(document).off('submit', '#verify_pin form');

    form.trigger('submit');

    return false;
  }

  content_map.form_name = 'verify_pin';

  window.doServerCall(content_map, window.cb_verifypin);

  return false;
});
